import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import {
  updateTeamApproverApi,
  UpdateTeamApproverPayload,
  UpdateTeamApproverResponse,
} from 'TeamModule/services/UpdateTeamApproverApi';
import { AxiosResponse } from 'axios';
import { teamQueryKeys } from '../teamQueryKeys';
import { useContextHeaders } from 'hooks/useContextHeaders';

export const useUpdateTeamApproverMutation = () => {
  const token = useSelector(selectAuthToken);
  const queryClient = useQueryClient();
  const { buildConfig } = useContextHeaders();

  const mutation = useMutation<
    AxiosResponse<UpdateTeamApproverResponse>,
    AxiosResponse<any>,
    UpdateTeamApproverPayload
  >({
    mutationFn: async (params) => {
      if (!token) throw new Error('No auth token available');
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      return updateTeamApproverApi({ params, token, config: buildConfig() }) as Promise<
        AxiosResponse<UpdateTeamApproverResponse>
      >;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: teamQueryKeys.listInvalidation({ identifier: 'useTeamsPendingDeletionQuery' }),
      });
    },
  });

  return {
    updateTeamApprover: mutation.mutate,
    isUpdatingTeamApprover: mutation.isPending,
  };
};
